import React from 'react'
import Header from './header'
import Hero from './hero'
import WalletConnect from './walletconnect'
import Footer from './footer'
import './App.css'
import './Hero.css'

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
      </main>
      <Footer />
    </div>
  )
}

export default App
